import moment, { Moment } from "moment";

export const timeConverter = (seconds: number, separator = ":") => {
  const days = Math.floor(seconds / 84400);
  const hours = Math.floor((seconds % 84400) / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const minTwoDigits = (n: number) => {
    return (n < 10 ? "0" : "") + n;
  };
  return days + " " + minTwoDigits(hours) + separator + minTwoDigits(minutes);
};

export const secondsToHours = (seconds: number) => {
  // convert seconds to hours to at most 2 decimal places
  const hours = Math.round((seconds / 3600) * 100) / 100;
  return hours;
};

export const secondsToHoursMinutes = (seconds: number) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  return {
    hours,
    minutes,
  };
};
export const secondsToDuration = (seconds: number) => {
  const { hours, minutes } = secondsToHoursMinutes(seconds);
  let minutesPadded = minutes + "";
  if (minutes < 10) {
    minutesPadded = "0" + minutesPadded;
  }
  return `${hours}:${minutesPadded}`;
};

export const hoursToSeconds = (hours: number) => {
  return hours * 3600;
};
export const minutesToSeconds = (minutes: number) => {
  return minutes * 60;
};

export const getCurrentTimestamp = () => {
  return moment().format("YYYY-MM-DDTHHmmss");
};

export const getDurationInSeconds = (startDate: Moment, endDate: Moment): number => {
  return endDate.diff(startDate, "seconds");
};

export const durationInputToSeconds = (duration: string) => {
  const durationHoursPart = parseInt(duration.split(":")[0], 10);
  const durationMinutesPart = parseInt(duration.split(":")[1], 10);
  let durationSeconds = 0;
  if (durationHoursPart) durationSeconds += hoursToSeconds(durationHoursPart);
  if (durationMinutesPart) durationSeconds += minutesToSeconds(durationMinutesPart);
  return durationSeconds;
};
